export const state = () => ({
  deliveryFreeFrom: null,
});

export const mutations = {
  init(state, deliveryFreeFrom) {
    state.deliveryFreeFrom = deliveryFreeFrom;
  },
};
